<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Sayfa Düzenle <small>( {{ title }} )</small></h3>
            </div>
            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <label for="title">Başlık</label>
                  <input type="text" v-model="title" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="slug">SEF Link</label>
                  <input type="text" v-model="slug" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="keywords">Meta Keywords</label>
                  <input type="text" v-model="keywords" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="description">Meta Description</label>
                  <input type="text" v-model="description" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="content">İçerik</label>
                  <vue-editor :editorToolbar="customToolbar" v-model="content" class="editor"></vue-editor>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="updateData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";


export default {
  components: { VueEditor },

  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }]
      ],
      id: this.$route.params.id,
      title: '',
      keywords: '',
      description: '',
      content: '',
      api: "pages/"
    };
  },
  computed: {
    slug() {
      var slug = window.Slug(this.title)
      return slug
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.axios.get(this.api + this.id + '/edit').then(response => {
        this.title = response.data.title
        this.keywords = response.data.keywords
        this.description = response.data.description
        this.content = response.data.content
      })
    },
    updateData() {
      this.$Progress.start();
      this.axios
        .put(this.api + this.id, {
            title: this.title,
            slug: this.slug,
            keywords: this.keywords,
            description: this.description,
            content: this.content,
        })
        .then(this.$Progress.finish());
    }
  }
};
</script>

<style scoped>
</style>
